import { atom } from 'recoil';

const sessionStorageEffect = (key) => ({ setSelf, onSet }) => {
  const saved = sessionStorage.getItem(key);
  if (saved) {
    try { setSelf(JSON.parse(saved)); } catch (e) { /* ignore */ }
  }
  onSet((newValue, _, isReset) => {
    isReset
      ? sessionStorage.removeItem(key)
      : sessionStorage.setItem(key, JSON.stringify(newValue));
  });
};

export const subjectOptionDataState = atom({
  key: 'subjectState',
  default: {
    courseId: null,
    openYy: null,
    openTmGbn: null,
  },
  effects_UNSTABLE: [sessionStorageEffect('recoil_subjectOptionData')],
});
